import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as CheckboxPropsCUI,
} from '@chakra-ui/react';
import * as React from 'react';
import { InputPropsType } from '../Form.types';
import { OmitProps } from '../../utils/OmitProps';
import { CheckboxProps } from './Checkbox.types';

const CheckboxInput = OmitProps(ChakraCheckbox, ['fieldState', 'formState']);

export const Checkbox = ({
  label,
  checkboxLabel,
  ...props
}: CheckboxProps & InputPropsType & CheckboxPropsCUI) => {
  return (
    <CheckboxInput {...props} isChecked={props.isChecked}>
      {label || checkboxLabel}
    </CheckboxInput>
  );
};
